import axios from 'axios'

/**
 * Fetch diving meets from backend.
 * @param {Object} params
 */
export function fetchDivingMeets(params) {
  let path = `${process.env.API_URL}/diving`
  if (params) {
    path += '?'
    for (let [k, v] of Object.entries(params)) {
      path += k + '=' + v + '&'
    }
  }
  return axios.get(path)
  .then(response => {
    return response.data
  })
  .catch(error => {
    console.log(error)
  })
}

/**
 * Fetch weightlifting meets from backend.
 * @param {Object} params
 */
export function fetchWeightliftingMeets(params) {
  let path = `${process.env.API_URL}/weightlifting`
  if (params) {
    path += '?'
    for (let [k, v] of Object.entries(params)) {
      path += k + '=' + v + '&'
    }
  }
  return axios.get(path)
  .then(response => {
    return response.data
  })
  .catch(error => {
    console.log(error)
  })
}

/**
 * Dynamically gets an API method, based on sport name.
 * @param {String} sportName
 * @param {Object} params
 */
export function apiGetter(sportName, params) {
  if (sportName === 'diving') {
    return fetchDivingMeets(params)
  } else if (sportName === 'weightlifting') {
    return fetchWeightliftingMeets(params)
  } else {
    throw Error(`Invalid sportName: ${sportName}`)
  }
}


// WEBPACK FOOTER //
// ./src/api/index.js